{
  "es": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Añadir un responsable",
        "bulk_remove": "Quitar de la tarea",
        "change_status": "Cambiar estado",
        "confirm": "Marcar como completada",
        "create": "Tarea",
        "delete": "Eliminar responsable",
        "due_in_month": "En un mes",
        "due_in_two_weeks": "En dos semanas",
        "due_in_week": "En una semana",
        "due_remove": "Quitar fecha límite",
        "move_to_draft": "Poner en borrador",
        "reopen": "Reabrir",
        "selectAll": "Seleccionar las {total}",
        "send_and_notify": "Enviar y avisar",
        "set_due_date": "Establecer fecha límite",
        "set_status": "Establecer estado",
        "unSelectAll": "Deseleccionar todo"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Empleado",
        "partner": "Colaborador"
      },
      "attributes": {
        "assignee": "Responsable",
        "assignees": "Responsables",
        "comment": "Comentario",
        "created_at": "Creado",
        "document": "Documento",
        "due_date": "Fecha límite",
        "project": "Proyecto",
        "status": "Estado",
        "task": "Tarea",
        "unit": "Unidad"
      },
      "confirm": {
        "affected": "Esto afecta a {customers} y {team}.",
        "affected_customers": "Esto afecta a {customers}.",
        "affected_team": "Esto afecta a {team}.",
        "bulk_affected": "Esto escribe {count} tarea. | Esto escribe {count} tareas.",
        "bulk_delete_body": "La tarea sigue existiendo, en esta unidad y en todas las demás. Solo desaparecen las filas seleccionadas.",
        "bulk_delete_header": "¿Quitar estas tareas?",
        "complete_body": "Sus tareas se cierran para ellos y desaparecen de su lista, aunque no hayan hecho nada.",
        "complete_header": "¿Cerrar esta tarea para todos?",
        "customer_tasks": "{count} tarea de cliente | {count} tareas de cliente",
        "delete_body": "Solo desaparece esta asignación. La tarea conserva sus otros responsables y sus otras unidades.",
        "delete_header": "¿Eliminar a {name} de esta tarea?",
        "delete_sent_customers": "Esta ya se había enviado, así que también desaparece del portal de clientes de {unit}.",
        "delete_sent_team": "Esta ya se había enviado, así que también desaparece de la lista de {name}.",
        "draft_body": "La tarea desaparece hasta que se vuelva a enviar. Los correos que ya salieron siguen enviados.",
        "draft_header": "¿Volver a poner esta tarea en borrador?",
        "send_customers": "Los clientes ven la tarea de inmediato en su portal y reciben un aviso.",
        "send_header": "¿Enviar a las personas asignadas?",
        "send_permanent": "El envío no se puede deshacer. Volver a poner la tarea en borrador más tarde no retira el aviso.",
        "send_status": "Pasan a Solicitada.",
        "send_team": "Las personas del equipo reciben un aviso.",
        "team_tasks": "{count} tarea de equipo | {count} tareas de equipo"
      },
      "filters": {
        "due_window_values": {
          "month": "Vence en un mes",
          "none": "Sin fecha límite",
          "overdue": "Atrasada",
          "week": "Vence en una semana"
        },
        "show_only": "Mostrar solo",
        "show_only_values": {
          "customers": "Clientes",
          "mine": "Asignadas a mí",
          "team": "Equipo"
        }
      },
      "labels": {
        "add_assignee": "Añadir un responsable…",
        "add_customers": "Añadir clientes",
        "already_assigned": "Esta tarea ya está añadida a esta unidad.",
        "already_assigned_project": "Esta tarea ya está añadida a este proyecto.",
        "assignees": "Personas asignadas",
        "comment_earlier": "+{count} anteriores",
        "comment_earlier_round": "ronda anterior",
        "comment_placeholder": "p. ej. el contador era difícil de alcanzar, esta es la mejor foto que pude hacer",
        "comments_none": "El cliente no dejó ningún comentario.",
        "comments_title": "Comentarios sobre esta tarea",
        "completed": "Completadas",
        "confirm_message": "¿Seguro que quieres marcar esta tarea como completada?",
        "customers": "Clientes",
        "my_tasks": "Mis tareas",
        "no_assignees": "Todavía no hay responsables.",
        "no_assignments": "Todavía no hay tareas.",
        "no_assignments_task": "Todavía no hay asignaciones para esta tarea.",
        "no_assignments_unit": "Todavía no hay tareas para esta unidad.",
        "required": "Este campo es obligatorio",
        "selectOne": "Seleccione al menos una tarea.",
        "select_task": "Selecciona una tarea",
        "selected": "{selected} seleccionada | {selected} seleccionadas",
        "set_status_for": "Establecer el estado de {name}",
        "totalSelected": "Las {total} seleccionadas",
        "upload_hint": "Sube el documento o los documentos solicitados para completar esta tarea.",
        "uploaded_documents": "Documentos subidos"
      },
      "statuses": {
        "completed": "Completada",
        "draft": "Borrador",
        "requested": "Solicitada"
      },
      "toasts": {
        "bulk_delete": "Tareas quitadas",
        "bulk_update": "Tareas actualizadas",
        "completed": "Tarea completada",
        "create": "Tarea creada",
        "delete": "Responsable eliminado",
        "reopened": "Tarea reabierta",
        "update": "Tarea actualizada"
      }
    }
  }
}
